const Footer = () => {
    return (
        <div className="bg-black text-white text-center text-sm py-4">
            Copyright &copy; 2021 Kaung Myat Han
        </div>
    )
}

export default Footer
